import styled from "styled-components";

type SearchIconProps = {
    disabled?: boolean;
};

const Svg = styled.svg<SearchIconProps>`
    &:hover path:nth-child(1) {
        fill: #FFE6D1;
    }

    &:hover path:nth-child(2) {
        fill: #FE902F;
    }

    &:hover path:nth-child(3) {
        stroke: #FE902F;
    }

    &.disabled path:nth-child(1) {
        fill: #dcdcdc;
    }
    &.disabled path:nth-child(2) {
        fill: #4b4b4b;
    }
    &.disabled path:nth-child(3) {
        stroke: #4b4b4b;
    }
`;

const SearchIcon = ({ disabled = false }: SearchIconProps) => {
    return (
        <Svg className={`${disabled ? "disabled" : ""}`} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="white"/>
            <path d="M20.9304 13.2C24.1704 13.2 26.8004 15.83 26.8004 19.07C26.8004 22.31 24.1704 24.94 20.9304 24.94C17.6904 24.94 15.0604 22.31 15.0604 19.07C15.0604 15.83 17.7004 13.2 20.9304 13.2ZM20.9304 12C17.0304 12 13.8604 15.16 13.8604 19.07C13.8604 22.98 17.0204 26.14 20.9304 26.14C24.8404 26.14 28.0004 22.97 28.0004 19.07C28.0004 15.17 24.8404 12 20.9304 12Z" fill="black"/>
            <path d="M16.24 23.76L12 28" stroke="black" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round"/>
        </Svg>
    );
};

export default SearchIcon;
